/* ============
 * Card Transformer
 * ============
 *
 * The transformer for the credit card data.
 */

import Transformer from './Transformer'

const moment = require('moment')

export default class CardTransformer extends Transformer {
  /**
   * Method used to transform a fetched card.
   *
   * @param card The fetched card.
   *
   * @returns {Object} The transformed card.
   */
  static fetch (card) {
    return {
      id: card['cc_uid'],
      name: card['name'],
      type: card['type'],
      createdOn: moment(card['createdOn']).format('YYYY-MM-DD h:mm'),
      ccFirstLast: card['cc_first_last'],
      isActive: card['isActive'] || '',
      isMastercardActive: card['isMastercardActive'] || ''
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/CardTransformer.js